/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import cx from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles/index';
import { actAnyFieldUpdate, getValue } from 'actions/formActions';

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  formControlMargin0: {
    minWidth: '150px',
    width: '100%',
  },
  formControl: {
    marginTop: '10px',
    minWidth: '100%',
    '& label, > div': {
      paddingLeft: '10px',
      paddingRight: '10px',
    },
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  labelDiv: {
    display: 'flex',
    fontSize: 12,
    position: 'absolute',
    bottom: 10,
    width: 'max-content',
  },
  mandatory: {
    fontSize: '20px',
    color: 'red',
    marginRight: '10px',
  },
});

class FormDropDownListContent extends Component {
  constructor(props) {
    super(props);
    this.myValue = this.myValue.bind(this);
    this.myHelperText = this.myHelperText.bind(this);
    this.myUpdateFunc = this.myUpdateFunc.bind(this);
  }

  // shouldComponentUpdate(nextProps) {
  //   const { store, storeName, accessPath, disabled } = nextProps;
  //   const { store: lastStore, disabled: lastDisabled } = this.props;

  //   if (
  //     getValue(store[storeName].data, accessPath) ===
  //       getValue(lastStore[storeName].data, accessPath) &&
  //     disabled === lastDisabled
  //   ) {
  //     return false;
  //   }
  //   return true;
  // }

  myValue() {
    const { store, storeName, accessPath, numeric } = this.props;
    const val = getValue(store[storeName].data, accessPath) || '';
    return numeric && !isNaN(val) ? Number(val) : val;
  }

  myHelperText() {
    const { error } = this.props;
    return error || null;
  }

  myUpdateFunc(e) {
    const { storeName, accessPath, onChange, onFieldUpdate } = this.props;
    if (onChange) {
      onChange(e);
    }
    onFieldUpdate(storeName, accessPath, e.target.value);
  }

  render() {
    const {
      classes,
      className,
      storeName,
      accessPath,
      fieldName,
      noLabel,
      error,
      choices,
      noUnderline,
      shrink,
      disabled, // for statusWrapper
    } = this.props;

    const formClasses = cx(classes.root, classes.formControl, classes.textAlignLeft, className);
    const chosenValue = choices && choices.find((choice) => choice.value === this.myValue());

    return disabled ? (
      <TextField
        disabled
        fullWidth
        label={
          noLabel ? null : typeof accessPath[accessPath.length - 1] === 'string' ? (
            <div className={classes.labelDiv}>
              {T.translate(`${storeName}.${accessPath[accessPath.length - 1]}`)}
            </div>
          ) : (
            <div className={classes.labelDiv}>{T.translate(`${storeName}.${fieldName}`)}</div>
          )
        }
        error={error != null}
        value={chosenValue ? chosenValue.label : this.myValue()}
        helperText={this.myHelperText()}
        margin='normal'
        InputLabelProps={{ shrink }}
      />
    ) : (
      <FormControl className={formClasses}>
        {!noLabel && (
          <InputLabel htmlFor='title' shrink={shrink}>
            {typeof accessPath[accessPath.length - 1] === 'string' && !fieldName ? (
              <div className={classes.labelDiv}>
                {T.translate(`${storeName}.${accessPath[accessPath.length - 1]}`)}
              </div>
            ) : (
              <div className={classes.labelDiv}>{T.translate(`${storeName}.${fieldName}`)}</div>
            )}
          </InputLabel>
        )}
        <Select
          disableUnderline={noUnderline}
          value={this.myValue()}
          onChange={this.myUpdateFunc}
          input={<Input name='name' id='pulldown' />}>
          {choices &&
            choices.map((choice) => (
              <MenuItem key={choice.value} value={choice.value}>
                {choice.label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    );
  }
}

FormDropDownListContent.propTypes = {
  classes: PropTypes.object.isRequired,
  choices: PropTypes.array,
  fieldName: PropTypes.string,
  noLabel: PropTypes.bool,
  storeName: PropTypes.string.isRequired,
};

FormDropDownListContent.defaultProps = {
  choices: [],
};

const mapStateToProps = (state) => ({ store: state });

const mapDispatchToProps = (dispatch) => ({
  onFieldUpdate: (storeName, accessPath, newVal) => {
    dispatch(actAnyFieldUpdate(storeName, accessPath, newVal));
  },
});

const FormDropDownList = connect(mapStateToProps, mapDispatchToProps)(FormDropDownListContent);

export default withStyles(styles)(FormDropDownList);
